/*
 * Centralized header settings — single source of truth for HeaderBar.
 *
 * Used by HeaderBar (templates/index.tsx) and product headers.
 * Z-index strategy: container 99, back-button 100, consistent with footer (99).
 */

const notch = __PROPS__.deviceHasNotch;

export const headerSettings = {
	height: notch ? 74 : 50,
	dividerHeight: notch ? 18 : 0,
	iconSize: 22,
	backButtonWidth: 50,
} as const;

export const headerZIndex = {
	container: 99,
	backButton: 100,
} as const;
